// Dependencies
import { useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

// Styles & Components
import { PublicNav, AdminNav } from "../../data/Nav";
import { Container } from "../styles/Layout";

// Icons & Images
import { ReactComponent as Logo } from "../../assets/img/pp-logo-light.svg";

// Navigation
import DesktopMenu from "./DesktopMenu";
import AdminMenu from "./AdminMenu";
import BurgerMenu from "./BurgerMenu";
import { size } from "../styles/Breakpoints";

const NavWrapper = styled.div`
    background: ${(props) => (props.location === "admin" ? "#221f1f" : (props) => props.theme.darkblue)};
    position: sticky;
    position: relative;
    @media print {
        display: none;
    }
`;

const NavRow = styled.div`
    display: flex;
    justify-content: space-between;
    height: 3rem;
`;

/*
 * On desktop the logo scales with the page: one step (~86%, as 1.75rem to
 * 1.5rem) below the footer logo. The footer's is 70% of a 3.25fr grid column,
 * which measures out at 31.15% of the page container's content width, so this
 * is 26.7% (321px at 1280 wide, 363px at 1440). --content is that width: the
 * viewport less ~15px of scrollbar and the container's 2rem padding each side,
 * up to the container's 1370px maximum.
 *
 * The five-link menu (~420px) always fits beside it, including at 768px with
 * "Established 2010" hidden and at 992px where that text (~115px) comes back.
 * Adding links back to PublicNav would change that - re-measure first.
 */
const LogoLight = styled(Logo)`
    width: 100%;
    @media screen and (min-width: ${size.sm}px) {
        --content: min(100vw - 15px - 4rem, 1370px);
        display: block;
        width: calc(var(--content) * 0.267);
    }
    @media print {
        display: none;
    }
`;

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    @media print {
        display: none;
    }
`;

const logoStyle = {
    margin: "auto 1rem auto 0",
};

/*
 * Sized to its text on desktop: a percentage width grew with the larger logo
 * and crowded the menu. On mobile the 70% stays - the logo's width there is
 * derived from what this leaves over, so removing it enlarges the logo into
 * the burger button.
 */
const Established = styled.div`
    width: 70%;
    @media (min-width: ${size.sm}px) {
        width: auto;
    }
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
    & a {
        color: white;
        padding: 1rem 0;
        white-space: nowrap;
    }
   
    @media (max-width: ${size.md - 1}px) and (min-width: ${size.sm}px) {
        display: none;
    }
    @media (max-width: ${size.sm - 1}px) {
        font-size: 0.5rem;
    }
`;

export default function NavBar({ location, pageTitle }) {
    const [isDesktop, setIsDesktop] = useState(false);

    const detectDesktop = () => {
        window.outerWidth >= size.sm ? setIsDesktop(true) : setIsDesktop(false);
    };

    useLayoutEffect(() => {
        detectDesktop();
        window.addEventListener("resize", () => {
            detectDesktop();
        });
    }, []);

    return (
        <NavWrapper location={location}>
            <Container>
                <NavRow>
                    <LogoContainer>
                        <Link to="/" style={logoStyle}>
                            <LogoLight />
                        </Link>
                        <Established>
                           <Link to="/">
                                Established 2010
                            </Link>
                        </Established>
                    </LogoContainer>
                    {location === "public" ? (
                        <>
                            {isDesktop ? (
                                <DesktopMenu nav={PublicNav} currentPage={pageTitle} />
                            ) : (
                                <BurgerMenu nav={PublicNav} />
                            )}
                        </>
                    ) : (
                        <AdminMenu nav={AdminNav} currentPage={pageTitle} />
                    )}
                </NavRow>
            </Container>
        </NavWrapper>
    );
}
